import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Laman Utama", href: "/" },
  { label: "Tentang Kami", href: "/about" },
  { label: "Program", href: "/programs" },
  { label: "Derma", href: "/donate" },
  { label: "Latihan AI & Komputer", href: "/training" },
  { label: "Hubungi", href: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-white/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="flex items-center justify-between px-4 md:px-8 lg:px-12 py-3 md:py-4">
        <Link to="/" className="flex items-center gap-2.5 shrink-0">
          <img
            src="https://public.readdy.ai/ai/img_res/73f16efe-91a8-43ba-88ee-73b3c6770cba.png"
            alt="Logo PERTUBUHAN MULIA INSAN MALAYSIA"
            className="w-10 h-10 md:w-12 md:h-12 object-contain"
          />
          <span
            className={`font-semibold text-sm md:text-base leading-tight transition-colors ${
              scrolled || !isHome ? "text-teal-800" : "text-white"
            }`}
          >
            MULIA INSAN
          </span>
        </Link>

        {/* Desktop nav */}
        <div className="hidden lg:flex items-center gap-6">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                location.pathname === link.href
                  ? scrolled || !isHome
                    ? "text-primary-600"
                    : "text-primary-300"
                  : scrolled || !isHome
                  ? "text-gray-700"
                  : "text-white/90"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/donate"
            className="ml-2 px-5 py-2 text-sm font-semibold rounded-full bg-primary-600 text-white hover:bg-primary-700 transition-colors whitespace-nowrap"
          >
            Sumbang Sekarang
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          className="lg:hidden w-9 h-9 flex items-center justify-center"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i
            className={`ri-${menuOpen ? "close" : "menu"}-line text-xl ${
              scrolled || !isHome ? "text-gray-800" : "text-white"
            }`}
          />
        </button>
      </nav>

      {/* Mobile menu panel */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 ${
          menuOpen ? "max-h-[480px]" : "max-h-0"
        }`}
      >
        <div className="px-4 pb-6 pt-2 bg-white/95 backdrop-blur-md border-t border-gray-100">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`block py-3 text-sm font-medium border-b border-gray-100 ${
                location.pathname === link.href
                  ? "text-primary-600"
                  : "text-gray-700"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/donate"
            className="block mt-4 text-center px-5 py-2.5 text-sm font-semibold rounded-full bg-primary-600 text-white hover:bg-primary-700 transition-colors"
          >
            Sumbang Sekarang
          </Link>
        </div>
      </div>
    </header>
  );
}